import { get } from "lodash";
import { WIDGET } from "../contants/widgetElements";

export interface IWidgetFactory {
  create(): Promise<Record<string, any>>
}

export class WidgetFactory implements IWidgetFactory {
  constructor(private readonly signWidgetUrl: string) {}

  async create(): Promise<Record<string, any>> {
    const widget = new (window as any).EndUser(
      WIDGET.ID.PARENT,
      WIDGET.ID.MAIN,
      this.signWidgetUrl,
      get(window, "EndUser.FormType.ReadPKey"),
    );

    await this._load();
    return widget;
  }

  private _load(): Promise<void> {
    const widgetIframe = document.getElementById(WIDGET.ID.MAIN);

    return new Promise((resolve, reject) => {
      if (!widgetIframe) {
        return reject(new Error("Віджет підпису не був ініціалізований"));
      }

      widgetIframe.addEventListener("load", () => resolve());
    });
  }
}
